/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum EnEvaluationSurveyType {
    CUSTOM = 'CUSTOM',
    FES = 'FES',
    TWOMWT = 'TWO_MWT',
    CMI = 'CMI',
    HY = 'H&Y',
    MMSE = 'MMSE',
    FOG = 'FOG',
    SPPB = 'SPPB',
    MINIBEST = 'MINI_BEST',
    _4STEPS = '4STEPS',
    FLUENZAVERBALEFONEMICA = 'FLUENZA_VERBALE_FONEMICA',
    FLUENZAVERBALESEMANTICA = 'FLUENZA_VERBALE_SEMANTICA',
    SF36 = 'SF36',
    MOCA = 'MOCA',
    ABC = 'ABC',
    NFOG = 'NFOG',
    PDCRS = 'PD_CRS',
    PDQ8 = 'PDQ_8',
    VAS = 'VAS',
    BORG = 'BORG',
    MRC = 'MRC'
}

